import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { PaginationRequest } from '@shared/services';
import { RequestHelper } from '@shared/helpers/request.helper';

@Injectable({ providedIn: 'root' })
export class LearnerStudySpaceSessionApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) { }

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/learner-study-space-sessions`;
    }

    getSessions(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(this.url, { params: options });
    }

    getOptions(req: PaginationRequest, body?: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.post<any>(`${this.url}/options`, body || {}, { params: options });
    }

    createSession(session: any): Observable<any> {
        return this.httpClient.post<any>(this.url, session);
    }

    updateSession(session: any): Observable<any> {
        return this.httpClient.put<any>(this.url, session);
    }

    updateOwnSession(session: any): Observable<any> {
        return this.httpClient.put<any>(`${this.url}/self`, session);
    }

    deleteSession(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${id}`);
    }

    deleteOwnSession(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/self/${id}`);
    }

    getAttachments(sessionId: string): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/${sessionId}/attachments`);
    }

    deleteAttachment(sessionId: string, attachmentId: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${sessionId}/attachments/${attachmentId}`);
    }
}

